import React from "react";
import JobListingsSection from "../dashboard/JobListingsSection";
import { useTranslation } from "src/_common/hooks/useTranslation";

const JobListingsPage: React.FC = () => {
  const { t } = useTranslation("job-listings");

  return (
    <div className="dashboard-main">
      <div className="dashboard-header">
        <h1 className="dashboard-title">{t("pageTitle")}</h1>
        <p className="dashboard-subtitle">{t("pageSubtitle")}</p>
      </div>

      <JobListingsSection />
    </div>
  );
};

export default JobListingsPage;
